import Vue from 'vue';

// Vue Config
Vue.config.productionTip = false;
Vue.config.devtools = true;

// ----- Plugins -------
// Customs
import { KeySiteCore } from '../../mixins/KeySiteCore';
import UniqueIdPlugin from '../../plugins/UniqueIdPlugin.js';
import WindowWidthPlugin from '../../plugins/WindowWidthPlugin.js';

Vue.use(KeySiteCore);
Vue.use(UniqueIdPlugin);

// Components
import DefaultButton from '@c/DefaultButton';
import DefaultCard from '@c/DefaultCard';
import DefaultChip from '@c/DefaultChip';
import DefaultPicture from '@c/DefaultPicture';
import DefaultSection from '@c/DefaultSection';
import LoadMoreCards from '@c/LoadMoreCards';
import SplitBlock from '@c/SplitBlock';
import UserProfile from '@c/UserProfile';
import VideoYoutubePlayer from '@c/VideoYoutubePlayer';

// Mixins
import ResponsiveBackgroundImageMixin from '../../mixins/ResponsiveBackgroundImageMixin.js';

import store from '../../stores/storeBlog';

import './styles/main.scss';

new Vue({
	el: '#site',
	store,
	components: {
		DefaultButton,
		DefaultCard,
		DefaultChip,
		DefaultPicture,
		DefaultSection,
		LoadMoreCards,
		SplitBlock,
		UserProfile,
		VideoYoutubePlayer,
	},

	mixins: [ResponsiveBackgroundImageMixin],

	created() {
		Vue.use(WindowWidthPlugin, this.$store); // need the store instance in the plugin
	},
});
